import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ShortcutService {
    private shortcutSubject = new Subject<KeyboardEvent>();
    private isMac: boolean = /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);

    constructor() {
        this.listenToKeyboardEvents();
    }

    private listenToKeyboardEvents() {
        window.addEventListener('keydown', (event: KeyboardEvent) => {
            this.shortcutSubject.next(event);
        });
    }

    getShortcuts() {
        return this.shortcutSubject.asObservable();
    }
    isMacOS(): boolean {
        return this.isMac;
    }
}